import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getDriversDHTCounter } from '../../services/DriversService';
import { DHTCounterResponse } from '../../types/Drivers';

function useGetDHTCounterPerDriver(fleetId: string, driver: string): UseQueryResult<DHTCounterResponse> {
  return useQuery(
    ['drivers-dht-couter', fleetId, driver],
    async (): Promise<DHTCounterResponse> => getDriversDHTCounter(fleetId, driver),
    {
      retry: 1,
      retryDelay: 3000,
      keepPreviousData: true,
    },
  );
}

export default useGetDHTCounterPerDriver;
